import { render, staticRenderFns } from "./ImportEmplacamentoList.vue?vue&type=template&id=13a47925"
import script from "./ImportEmplacamentoList.vue?vue&type=script&lang=ts"
export * from "./ImportEmplacamentoList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports